module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body anchor",
    class: {
      'no-padding': _vm.anchors && _vm.anchors.length > 0
    }
  }, [_c('div', {
    staticClass: "anchor-button"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.confirmAnchor
    }
  }, [_c('i', {
    staticClass: "ion ion-android-lock lock-icon"
  }), _vm._v(" Anchor now\n      ")])]), _vm._v(" "), (_vm.anchors.length == 0) ? _c('p', {
    staticClass: "anchor-label"
  }, [_vm._v("This item has not been anchored yet")]) : _vm._e(), _vm._v(" "), (_vm.anchors.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped no-margin",
    attrs: {
      "role": "grid"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.anchors), function(anchor) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(_vm._f("prettyDateTime")(anchor.timestamp)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(anchor.anchoredBy.firstName) + " " + _vm._s(anchor.anchoredBy.lastName))]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "file-name",
      attrs: {
        "href": _vm.getUrl(anchor)
      }
    }, [_c('i', {
      staticClass: "fa fa-file clickable",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        "title": "Download"
      }
    })])])])
  }), 0)])])]) : _vm._e()]), _vm._v(" "), _c('confirm-modal', {
    attrs: {
      "message": "Do you really want to secure and anchor this item ?",
      "title": "Secure Confirmation",
      "id": "ConfirmAnchorModal"
    },
    on: {
      "confirm": function($event) {
        return _vm.anchor()
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Anchors")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "aria-label": "Achor Date",
      "colspan": "1",
      "rowspan": "1",
      "tabindex": "0"
    }
  }, [_vm._v("Anchor Date")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "User",
      "colspan": "1",
      "rowspan": "1",
      "tabindex": "0"
    }
  }, [_vm._v("User")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "file",
      "colspan": "1",
      "rowspan": "1",
      "tabindex": "0"
    }
  }, [_vm._v("File")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-93c25744"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Anchors.vue
// module id = 450
// module chunks = 1